// @flow

import * as React from 'react';
import { connect } from 'react-redux';
import { actions } from '@ta/common.state';

type ExternalProps = {|
  name?: ?string,
  local?: boolean,
  children: (() => void, boolean) => React.Node,
|};

type Props = {|
  ...ExternalProps,
  isOpen: boolean,
  showGlobal: (name: ?string) => void,
  hideLocal: (name: string) => void,
|};

/**
 * The Closer component accepts a Render prop as a child, to which it provides a function that will close an overlay.
 * By default, the Closer will close the Global overlay, whatever it may be. You can close a local overlay by passing
 * an overlay name explicitly.
 */
const Closer = ({ name, showGlobal, hideLocal, isOpen, children }: Props) =>
  children(() => (name ? hideLocal(name) : showGlobal(null)), isOpen);

Closer.defaultProps = {
  name: null,
};

export default connect<Props, ExternalProps, _, _, _, _>(
  (state, props: ExternalProps) => ({
    ...props,
    isOpen: props.local ? state.overlays.locals[props.name] : state.overlays.global === props.name,
  }),
  {
    showGlobal: actions.overlays.showGlobalOverlay,
    hideLocal: actions.overlays.hideLocalOverlay,
  },
)(Closer);
